/*@flow*/
import * as t from 'lib/t';
import enumList from '../util/enumList';
import CheckboxGroup from './templates/CheckboxGroup';
import Section from './templates/Section';
import RangeTemplate from './templates/RangeTemplate';
import isEmbedded from 'lib/isEmbedded';
import StatusesTemplate from './templates/Statuses';

const RangeType = t.struct({
  min: t.Number,
  max: t.Number,
});

const config = {
  status: t.list(t.String).opt({
    label: 'Status',
    template: StatusesTemplate,
    filterName: 'listings',
    hideWhen: isEmbedded,
  }),
  listingType: t.enums
    .of(enumList.listingType)
    .opt({ template: CheckboxGroup, nullOption: false }),
  propertyType: t.enums.of(enumList.propertyType).opt({
    template: CheckboxGroup,
    nullOption: false,
    // hideWhen: isEmbedded,
  }),
  rentableSqft: RangeType.opt({
    min: 0,
    max: 2000000000,
    template: RangeTemplate,
    label: 'Rentable Space (Square Feet)',
  }),
  pricePerSqft: RangeType.opt({
    min: 0,
    max: 2000000000,
    template: RangeTemplate,
    label: 'Price per sq ft',
  }),
};

export default t.struct(config).opt<any>({
  label: 'Real Estate Listings',
  iconClass: 'fa-building',
  template: Section,
});
